export default __webpack_public_path__ + "static/media/sea.23262fcf.svg";